export const formatCurrency = (
  valor,
  localidade = "pt-BR",
  casasDecimais = 2
) => {
  return valor.toLocaleString(localidade, {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: casasDecimais,
    maximumFractionDigits: casasDecimais,
  });
};

export const formatBoolean = (valor) => {
  return valor ? "Sim" : "Não";
};

export const getSubdomain = (location) => {
  const locationParts = location.split(".");
  // console.log(locationParts[1]);

  let sliceTill = -2;

  const isLocalHost = locationParts.slice(-1)[0] === locationParts[1];
  if (isLocalHost) {
    sliceTill = -1;
  }

  return locationParts.slice(0, sliceTill).join("");

  //   return locationParts[0];
};